// import moment from 'moment-timezone';
import { api } from '@/f1/service';
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/f1/custom';
import Language from './language';
import _ from 'lodash';

//restful api
// import { wsfinder as wf } from '@/f1/service/api';

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  sk : '', sv : '', skt : '', opt : { },
  created_at_ed : moment().add(1, 'day'),
  created_at_sd : moment().add(-1, 'month'),
})

export default {
  components: { DatePicker, Language },
  data: () => { return { moment, custom, so : default_opt(), date_check: undefined, year_modal : false, date_modal : false, } },
  computed: {
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields : function() { return i18n_toastr.i18n_fields[this.i18n]}
  },
  methods: {
    reset() { this.so = default_opt(); this.$refs._list.refresh(); },
    refresh() { console.log('refresh'); this.$refs._list.refresh();},
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        target : 'result', cmd : 'list',
        body : { sort : [{ name : 'id', op : 'desc'}], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * 10, limit: 10, // 10 은 나중에 변수 처리해야함.
      }

      if((!this.so.created_at_sd || !this.so.created_at_ed)){
        this.date_modal = true;
        return this.date_modal
      }

      // 조회 기간 최대 1년
      this.date_check = this.checkdate();
      if(this.date_check > 365){
        this.year_modal = true;

        return this.year_modal
      }

      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if((this.so.sv || '').trim()) { so.body.and = [ { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      if(this.so.created_at_ed) { so.body.and.push({ name : 'created_at', value : this.so.created_at_ed, op : '<='}); }
      if(this.so.created_at_sd) { so.body.and.push({ name : 'created_at', value : this.so.created_at_sd, op : '>='}); }

      return api.wsfinder.WSFinder(so).then(rs => {
      //return wf.result.list(so).then(rs => {
        this.so.totalRows = rs.total;
        _.forEach(rs.body, x => {
          let sec = moment(x.created_at).diff(moment(x.scan_time), 'seconds')
          x.scanning_time =  `${Math.floor(sec / 60) < 0 ? 0 : Math.floor(sec / 60)}:${`${sec % 60 < 0 ? 0 : sec % 60}`.padStart(2, '0')}`
        })
        return rs.body
      }).catch(e => this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) );
    },
    detail: function(item) { this.$router.push(`result/${item.id}`); },
    hideList: function(e) {
      this.show = !e; console.log('Result.List.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
    },
    checkdate(){  //최대기간 설정
      let sd = moment(this.so.created_at_sd)
      let ed = moment(this.so.created_at_ed)

      let check_date = ed.diff(sd, 'day');
      return check_date
    }
  },
  created: function() {   console.log('Result.List.vue', 'created'); },
  destroyed: function() { console.log('Result.List.vue', 'destroyed'); },
  mounted: function() { console.log('Result.List.vue', 'mounted'); },
}
